import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as Actions from "../actions/PurchaseOrderApiActions";
import {showModalWindow, removeModalWindow} from "../actions/WindowActions";
import {Map} from "immutable";

function* requestCreatePurchaseOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreatePurchaseOrderWindow", {}, "Create Purchase Order", Map({width: "60vw"})));
  yield take([Actions.CREATE_PURCHASE_ORDER.CANCEL, Actions.CREATE_PURCHASE_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreatePurchaseOrder() {
  yield takeLatest(Actions.REQUEST_CREATE_PURCHASE_ORDER, requestCreatePurchaseOrder);
}

function* requestEditPurchaseOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditPurchaseOrderWindow", {purchaseOrderId: baseAction.purchaseOrderId}, "Edit Purchase Order"));
  yield take([Actions.EDIT_PURCHASE_ORDER.CANCEL, Actions.EDIT_PURCHASE_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditPurchaseOrder() {
  yield takeLatest(Actions.REQUEST_EDIT_PURCHASE_ORDER, requestEditPurchaseOrder);
}

function* requestEditPurchaseOrderLines(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditPurchaseOrderLinesWindow", {purchaseOrderId: baseAction.purchaseOrderId}, "Edit Lines", Map({width: "60vw"})));
  yield take([Actions.EDIT_PURCHASE_ORDER_LINES.CANCEL, Actions.EDIT_PURCHASE_ORDER_LINES.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditPurchaseOrderLines() {
  yield takeLatest(Actions.REQUEST_EDIT_PURCHASE_ORDER_LINES, requestEditPurchaseOrderLines);
}

function* requestPlacePurchaseOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "PlacePurchaseOrderWindow", {purchaseOrderId: baseAction.purchaseOrderId}, "Place Purchase Order"));
  yield take([Actions.PLACE_PURCHASE_ORDER.CANCEL, Actions.PLACE_PURCHASE_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestPlacePurchaseOrder() {
  yield takeLatest(Actions.REQUEST_PLACE_PURCHASE_ORDER, requestPlacePurchaseOrder);
}

function* requestReceivePurchaseOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ReceivePurchaseOrderWindow", {purchaseOrderId: baseAction.purchaseOrderId}, "Receive Purchase Order", Map({width: "60vw"})));
  yield take([Actions.RECEIVE_PURCHASE_ORDER.CANCEL, Actions.RECEIVE_PURCHASE_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestReceivePurchaseOrder() {
  yield takeLatest(Actions.REQUEST_RECEIVE_PURCHASE_ORDER, requestReceivePurchaseOrder);
}

function* requestCancelPurchaseOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelPurchaseOrderWindow", {purchaseOrderId: baseAction.purchaseOrderId}, "Cancel Purchase Order"));
  yield take([Actions.CANCEL_PURCHASE_ORDER.CANCEL, Actions.CANCEL_PURCHASE_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelPurchaseOrder() {
  yield takeLatest(Actions.REQUEST_CANCEL_PURCHASE_ORDER, requestCancelPurchaseOrder);
}

export default function* saga() {
  yield fork(watchRequestCreatePurchaseOrder);
  yield fork(watchRequestEditPurchaseOrder);
  yield fork(watchRequestEditPurchaseOrderLines);
  yield fork(watchRequestPlacePurchaseOrder);
  yield fork(watchRequestReceivePurchaseOrder);
  yield fork(watchRequestCancelPurchaseOrder);
}
